import React from "react";
import { Link } from "react-router-dom";
import backgroundImage from "../../assets/subfooter.jpg";
import ScrollToTopButton from "./ScrollButton";

const FullScreenImage = () => {
  return (
    <section
      className="relative h-[80vh] bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="absolute inset-0 bg-black opacity-60"></div>{" "}
      {/* Dark overlay */}
      <div className="relative z-10 flex flex-col justify-center items-center h-full text-white text-center">
        <h2 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-12 sm:mb-16 md:mb-20 px-4">
          STEP INTO YOUR FUTURE
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 items-center justify-center">
          <Link to="/contact" className="bg-custom-pink font-bold py-2 sm:py-3 md:py-4 px-6 sm:px-8 md:px-12 lg:px-20 rounded-full text-white hover:bg-opacity-80 transition duration-300 text-center w-full sm:w-auto">
            REQUEST MORE INFO
          </Link>
          <a href="https://apply.jrsys.ac.tz/" target="_blank" rel="noreferrer" className="bg-gold py-2 font-bold sm:py-3 md:py-4 px-6 sm:px-8 md:px-12 lg:px-20 rounded-full text-white hover:bg-opacity-80 transition duration-300 text-center w-full sm:w-auto">
            APPLY NOW
          </a>
          <Link to="/programs" className="bg-custom-pink font-bold py-2 sm:py-3 md:py-4 px-6 sm:px-8 md:px-12 lg:px-20 rounded-full text-white hover:bg-opacity-80 transition duration-300 text-center w-full sm:w-auto">
            EXPLORE PROGRAMS
          </Link>
        </div>
      </div>
      <ScrollToTopButton />
    </section>
  );
};

export default FullScreenImage;
